export const productImages = {
  medrixo: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/products/medrixo.webp",
    mockup:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/products/medrixo-mockup.webp",
  },
  taxongo: {
    hero: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/products/taxongo.webp",
    mockup:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/products/taxongo-mockup.webp",
  },
};
